import { render } from "./atendimentos-list.vue?vue&type=template&id=040c3db6"
import script from "./atendimentos-list.vue?vue&type=script&lang=js"
export * from "./atendimentos-list.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__